import React, { useEffect, useState } from "react";
import { Button, FloatingLabel, Form, Modal, Spinner } from "react-bootstrap";
import { LicenseJsonModel, ModeJsonModel } from "../../models/BlockTransportSystemJsonModel";
import { UserPermissionModel } from "../../controllers/StudioAdminController";
import { inject, observer } from "mobx-react";
import BlockKitStore from "../../stores/BlockKitStore";
import StudioUserStore from "../../stores/StudioUserStore";
import { useTranslation } from "react-i18next";


interface IProps {
  blockKitStore?: BlockKitStore;
  studioUserStore?: StudioUserStore;
  isShow: boolean;
  license?: LicenseJsonModel;
  modes?: ModeJsonModel[];
  onSave: (modeIds: string[]) => Promise<void>;
  onClose: () => void;
}

const LicenseModeEditModal: React.FC<IProps> = inject("blockKitStore", "studioUserStore")(observer(({
  blockKitStore,
  studioUserStore,
  isShow,
  license,
  modes,
  onSave,
  onClose
}: IProps) => {
  const [selectedModeIds, setSelectedModeIds] = useState<string[]>([]);
  const [permissions, setPermissions] = useState<UserPermissionModel[]>([]);
  const [isWorking, setIsWorking] = useState<boolean>(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (license?.id) {
      blockKitStore?.studioController.getEntityPermissionsAsync("licenses", license.id).then(setPermissions);
      blockKitStore?.studioController.getLicenseModesStagingAsync(license.id).then((res) => setSelectedModeIds(res.map(i => i.modeId)))
    }
  }, []);

  const handleCheckboxChange = (modeId: string) => {
    setSelectedModeIds((prev) =>
      prev.includes(modeId)
        ? prev.filter((id) => id !== modeId) // 이미 선택된 경우 제거
        : [...prev, modeId] // 새로 선택된 경우 추가
    );
  };

  return (
    <Modal show={isShow} onHide={() => onClose()}>
      <Modal.Header closeButton>{t("mode")}</Modal.Header>
      <Modal.Body>
        <FloatingLabel label={"ID"} className="mb-2">
          <Form.Control type="text" value={license?.id} />
        </FloatingLabel>
        <FloatingLabel label={"NAME"} className="mb-2">
          <Form.Control type="text" value={license?.name} />
        </FloatingLabel>
        <Form className="border rounded p-2">
          {modes?.map((mode) => (
            <Form.Check
              key={mode.id}
              type="checkbox"
              id={`mode-${mode.id}`}
              checked={selectedModeIds.includes(mode.id ?? "")}
              onChange={() => handleCheckboxChange(mode.id ?? "")}
              label={mode.name}
            />
          ))}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          disabled={!studioUserStore?.hasWritePermission(permissions) || isWorking}
          variant="primary"
          onClick={async () => {
            setIsWorking(true);
            try {
              await onSave(selectedModeIds);
            } finally {
              setIsWorking(false);
            }
          }}>
          {isWorking &&
            <Spinner
              className="me-1"
              animation="border"
              size="sm"
              role="status"
            />}
          {t("button-save")}
        </Button>
        <Button
          disabled={isWorking}
          variant="secondary"
          onClick={() => onClose()}>
          {t("button-close")}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}));

export default LicenseModeEditModal;